import { pickBy } from "ramda"
import { isNotNullOrEmpty, isset, isNotEmptyString } from "./validate"
import { formatHKTimeZone } from "./formatter"

export function processContactInfo(companyInfo) {
  return {
    email: isNotNullOrEmpty(companyInfo?.email) ? companyInfo.email : "",
    salutation: isNotNullOrEmpty(companyInfo?.contactPerson) ? companyInfo.contactPerson.title.code : "",
    firstName: isNotNullOrEmpty(companyInfo?.contactPerson) ? companyInfo.contactPerson.firstName.trim() : "",
    lastName: isNotNullOrEmpty(companyInfo?.contactPerson) ? companyInfo.contactPerson.lastName.trim() : "",
    phoneCountry: isNotNullOrEmpty(companyInfo?.telephone) ? `+${companyInfo.telephone.countryCode.callCode}` : "",
    phoneArea: isNotNullOrEmpty(companyInfo?.telephone) ? companyInfo.telephone.areaCode.trim() : "",
    phoneNumber: isNotNullOrEmpty(companyInfo?.telephone) ? companyInfo.telephone.number.trim() : "",
    phoneExt: isNotNullOrEmpty(companyInfo?.telephone) ? companyInfo.telephone.extension.trim() : "",
    address1: isNotNullOrEmpty(companyInfo?.address) ? companyInfo.address.firstRow.trim() : "",
    address2: isNotNullOrEmpty(companyInfo?.address) ? companyInfo.address.secondRow.trim() : "",
    address3: isNotNullOrEmpty(companyInfo?.address) ? companyInfo.address.thirdRow.trim() : "",
    address4: isNotNullOrEmpty(companyInfo?.address) ? companyInfo.address.fourthRow.trim() : ""
  }
}

export function processBRObj(brObj) {
  return pickBy((val, key) => {
    if (key === "image") return isNotEmptyString(val.url)
    else if (key === "number") return isNotEmptyString(val)
    else return isset(val)
  }, brObj)
}

export function convertCountryToCurrency(countryID) {
  if (countryID === "CHN") return "RMB"
  if (countryID === "HKG") return "HKD"
  return "USD"
}

const processCompanyInfo = (companyInfo) => {
  const brObj = {
    number: companyInfo.BRDetails.number.trim(),
    validStart: isset(companyInfo.BRDetails.commencementDate) ? formatHKTimeZone(companyInfo.BRDetails.commencementDate) : null,
    validEnd: isset(companyInfo.BRDetails.expiryDate) ? formatHKTimeZone(companyInfo.BRDetails.expiryDate) : null,
    image: {
      url: isNotNullOrEmpty(companyInfo.BRDetails.file) && isNotNullOrEmpty(companyInfo.BRDetails.file.result) ? companyInfo.BRDetails.file.result.url : ""
    }
  }

  let br = processBRObj(brObj)

  let returnObj = {
    status: "DETAIL",
    salesCode: companyInfo.saleRepCode.trim(),
    currency: convertCountryToCurrency(companyInfo.region?.country?.id),
    customer: {
      contact: processContactInfo(companyInfo),
      nameTC: companyInfo.nameTC.trim(),
      nameSC: companyInfo.nameSC.trim(),
      businessNatures: companyInfo.natureOfBusiness ? companyInfo.natureOfBusiness.map((item) => item.code) : "",
      countryCode: isNotNullOrEmpty(companyInfo.region) ? companyInfo.region.country.id : "",
      provinceCode: isNotNullOrEmpty(companyInfo.region) ? companyInfo.region.state.id : "",
      cityCode: isNotNullOrEmpty(companyInfo.region) ? companyInfo.region.city.id : "",
      emailPreferLang: isNotNullOrEmpty(companyInfo.emailLangPef) ? companyInfo.emailLangPef.lang : ""
    }
  }

  if (isNotNullOrEmpty(br)) {
    returnObj = { ...returnObj, br }
  }

  if (isNotEmptyString(companyInfo.CCDID)) {
    returnObj = { ...returnObj, customer: { ...returnObj.customer, CCDID: companyInfo.CCDID.trim() } }
  }

  return returnObj
}

export default processCompanyInfo
